import React, { useState, useEffect } from 'react'
import {Form, Button} from "react-bootstrap";
import axios from 'axios';
import * as signalR from "@microsoft/signalr";
import 'leaflet/dist/leaflet.css';
import './ConsoleModemCard.css';

const OnlineIcon = React.memo(({ type }) => {
    const src = type === 1 ? "/image/modem/online_plane.svg" : "/image/modem/online.svg";
    return <img className='modem-card-online-icon' src={src} title="Online" />;
});

const OfflineIcon = React.memo(({ type }) => {
    const src = type === 1 ? "/image/modem/offline_plane.svg" : "/image/modem/offline.svg";
    return <img className='modem-card-online-icon' src={src} title="Offline" />;
});

const UpdateIcon = React.memo(({ version, update, upgrade }) => {
    if (version < 2000) return <div></div>;

    if (upgrade) {
        return (
            <img
                className='modem-card-update-icon'
                src="/image/modem/upgrade.svg"
                title="Требуется обновление"
                width="25px"
            />
        );
    }

    if (update !== 0) {
        return (
            <img
                className='modem-card-update-icon'
                src="/image/modem/update.svg"
                title="Требуется обновление"
                width="25px"
            />
        );
    }

    return <div></div>;
});

function ConsoleModemCard({imei, isOnline, onClick, isActive, modemName, version, update, upgrade, isArm, mavType}){
    const handleClick = () => onClick(imei);
    
    function modemVersionName(version) {
        if(version < 2000) {
            return "Telem" 
        }
        if(version < 3000) {
            return "EYE"
        }
    }

    return (
        <div
            className={`console-modem-card${isActive ? ' console-active-modem-card' : ''}`}
            onClick={handleClick}
        >
            <div className='console-modem-card-content'>
                <div>
                    <div className='modem-card-name'>{modemName}</div>
                    <div className='modem-card-imei'>{imei}</div>
                    <div className='modem-card-arm'>{isArm ? 'ARM' : 'DISARM'}</div>
                </div>
                <div className='online-update'>
                    <UpdateIcon version={version} update={update} upgrade={upgrade} />
                    {isOnline ? (
                        <OnlineIcon type={mavType} />
                    ) : (
                        <OfflineIcon type={mavType} />
                    )}
                </div>
            </div>
        </div>
    );
}

function areEqual(prevProps, nextProps) {
    return (
        prevProps.imei === nextProps.imei &&
        prevProps.isOnline === nextProps.isOnline &&
        prevProps.isActive === nextProps.isActive &&
        prevProps.modemName === nextProps.modemName &&
        prevProps.version === nextProps.version &&
        prevProps.update === nextProps.update &&
        prevProps.upgrade === nextProps.upgrade &&
        prevProps.isArm === nextProps.isArm &&
        prevProps.mavType === nextProps.mavType
    );
}

export default React.memo(ConsoleModemCard, areEqual);
